module.exports = __webpack_public_path__ + "static/scale-model-of-cheetah-hunt-in-tampa-florida-2d7189b6f2351b60784a9c069ca50319.png";